import defaultAvatar from '../assets/logo.jpg';

export const getUserAvatarUrl = (photoUrl?: string | null): string => {
  if (photoUrl && photoUrl.trim().length > 0) {
    return photoUrl;
  }

  return defaultAvatar;
};
